import { useState } from 'react';
import { List, ListItem, Checkbox, ListItemButton, ListItemAvatar, ListItemText, Avatar, IconButton } from '@mui/material';
import { AddCircle } from '@mui/icons-material';
import SearchComponent from './Search';
import ArticuloService from '../services/articulos';
import { OPERATION } from '../helpers/enums';

const SelectItem = ({ items, onSearch, onSelect }) => {
  const [checked, setChecked] = useState([]);

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const handlerOnSelect = (id) => {
    onSelect && onSelect(id)
  }

  return (<>
    <SearchComponent onSearch={onSearch} searchWhenType/>
    <List dense sx={{ width: '100%', maxWidth: "100%", bgcolor: 'background.paper', marginTop: 3 }}>
      {items?.map(({ id, name, image, description, available }, index) => {
        const labelId = `checkbox-list-secondary-label-${id}`;
        return (
          <ListItem
            key={id}
            secondaryAction={
              <IconButton
                id="add-cart"
                onClick={() => onSelect(items[index])}
                disabled={!available}
              >
                <AddCircle />
              </IconButton>
            }
            disablePadding
          >
            <ListItemButton disabled={!available}>
              <ListItemAvatar>
                <Avatar
                  alt={`Avatar n°${index + 1}`}
                  src={image}
                />
              </ListItemAvatar>
              <ListItemText id={labelId} primary={name} secondary={description}/>
            </ListItemButton>
          </ListItem>
        );
      })}
    </List>
  </>);
}

export default SelectItem;